import React from 'react'
import ReactDOM from 'react-dom'
import "./assets/style.css"
import quizService from "./quizService"
import QuestionBox from "./components/QuestionBox"
import Result from './components/Result'

class QuizApp extends React.Component{
  constructor (props){
    super(props);

    this.state={
      quizbank : [],
      score: 0,
      response: 0

    }
  }
// play Agaim

playAgain = () => {
  this.getQuestions()
  this.setState({
    score: 0,
    response: 0
  })
} 

// compute Answer
computeAnswer = (answer, correct) => {
  if (answer === correct) {
    this.setState({
      score: this.state.score + 1,

    })
  }
  this.setState({
    response: this.state.response < 5 ? this.state.response + 1 : 5
  })
}
    // fetch data from the quizservice Api
getQuestions(){
  quizService().then(message =>{
        this.setState({
          quizbank: message
        })
      })
    }
  
    // componenDidMount
    componentDidMount(){
      this.getQuestions()
    }

  render(){
    return(
      <div className="container">
        <div className="title">LetsQuiz</div>
        {this.state.quizbank.length > 0 && this.state.response < 5  && this.state.quizbank.map(
          ({question, answers, correct, questionId}) => (
          < QuestionBox question = {question} options={answers} key={questionId}  selected = {answer => this.computeAnswer(answer, correct)} />
         
       ))}
     
      {this.state.response === 5 ? (<Result score={this.state.score} playAgain= {this.playAgain} />): null}

      </div>
    )
  }
}

ReactDOM.render(<QuizApp /> , document.getElementById("root"))